import type { DespesaExtratoEventoItem } from "../../../services/FinanceiroService";

export type HistoryPaymentRow = {
  id: number;
  acao: string;
  data: string | null;
  arquivoId: number | null;
};

/** Converte eventos V2 (nome/criadoEm/arquivoId) para o shape do HistoryPayment. */
export const mapDespesaExtratoEventosToHistoryRows = (
  eventos: DespesaExtratoEventoItem[] | null | undefined,
): HistoryPaymentRow[] => {
  if (!Array.isArray(eventos)) return [];

  return eventos.map((entry, i) => {
    const arquivoRaw = entry?.arquivoId;
    const arquivoNum = Number(arquivoRaw);
    const arquivoId =
      arquivoRaw != null && Number.isFinite(arquivoNum) && arquivoNum > 0
        ? arquivoNum
        : null;

    return {
      id: entry?.id ?? i,
      acao: entry?.nome ?? "-",
      data: entry?.criadoEm ?? null,
      arquivoId,
    };
  });
};
